import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    debug: false,

    interpolation: {
      escapeValue: false, // React gère déjà le XSS
    },

    backend: {
      loadPath: `${process.env.PUBLIC_URL || ""}/locales/{{lng}}/{{ns}}.json`,
    },

    ns: ["common"],
    defaultNS: "common",
  });

export default i18n;
